import React from "react";
import "../WomenDevelopment/women.css";
import bannerImage from "../../assets/women1.jpeg"; // Replace with your banner image
import image1 from "../../assets/women2.jpeg"; // Replace with your first content image
import image2 from "../../assets/women3.jpeg"; // Replace with one of the smaller side-by-side images
import image3 from "../../assets/women4.jpeg"; // Replace with the other smaller side-by-side image
import smallImage from "../../assets/women5.jpeg"; // Replace with the smaller image below "Why It's Special"

const WomenDevelopment = () => {
  return (
    <div className="women-development-page">
      {/* Banner Section */}
      <div className="banner">
        <img src={bannerImage} alt="Women Development Banner" className="women-img"/>
      </div>

      {/* Introduction Paragraph */}
      <div className="intro">
        <h3>Residential camp organized by women for women <i>"Mahercha Umbartha"</i></h3>
        <p>
          The "Mahercha Umbartha" residential camp is an inspiring initiative tailored specifically to support and uplift women, particularly housewives, who often dedicate their lives to their families and households without prioritizing their own needs. Organized by the <b>Tarunai Foundation Khamgaon,</b> this camp serves as a retreat for women aged 35 to 55, providing them with opportunities for self-discovery, personal growth, and relaxation amidst the serene surroundings of <b>Salaiban,</b> nestled at the foot of the Satpuda hills.
        </p>
      </div>

      {/* Key Initiatives and Image Section */}
      <div className="key-initiatives-women">
        <div className="text">
          <h2>Key Features of the Camp</h2>
          <ul>
            <li><strong>Holistic Well-being Focus:</strong> 
                <ul>
                    <li>Guidance from expert female doctors on physical and mental health.</li>
                    <li>Yoga and meditation sessions led by female instructors to promote mindfulness and fitness.</li>
                </ul>
             </li>
            <li><strong>Skill and Knowledge Development:</strong>
              <ul>
                <li>Practical training in kitchen gardening (backyard gardening).</li>
                <li>Legal awareness sessions to empower women with knowledge of their rights.</li>
                <li>Tips and techniques for managing domestic challenges effectively.</li>
              </ul>
              </li>
            <li><strong>Recreational and Cultural Activities:</strong> 
               <ul>
                    <li>Nature walks and trekking to explore the scenic beauty of Salaiban.</li>
                    <li>Traditional games, competitions, and hobbies to encourage creativity and camaraderie.</li>
                    <li>Cultural programs under the moonlight to celebrate art and self-expression.</li>
               </ul>
             </li>
            <li><strong>Social and Emotional Connection:</strong>
             <ul>
                <li>Opportunities to bond with other women, share experiences, and build friendships.</li>
                <li>A safe space to rediscover talents, express individuality, and enjoy moments of joy and laughter.</li>
             </ul>
            </li>
          </ul>
        </div>
        <div className="image">
          <img src={image1} alt="Key Features" />
        </div>
      </div>

      {/* Side-by-Side Images */}
      <div className="image-pair">
        <img src={image2} alt="Activity 1" />
        <img src={image3} alt="Activity 2" />
      </div>

      {/* Why It's Special Paragraph */}
      <div className="why-special">
        <h2>Why It's Special</h2>
        <p>
          The camp transcends the usual idea of a retreat by combining leisure with learning. It addresses the physical, emotional, and intellectual health of women, empowering them to lead stress-free and fulfilling lives. Each year brings fresh themes and topics, ensuring a dynamic and enriching experience for participants.
        </p>
        <p>
          The overwhelming response from women over the past three years highlights the camp's success in meeting a crucial need for self-care and personal growth among housewives. It’s more than just a getaway—it's a life-enriching experience.
        </p>
      </div>

      {/* Small Image Section */}
      <div className="small-image">
        <img src={smallImage} alt="Why It's Special" />
      </div>

      {/* True Maher Ghar Paragraph */}
      <div className="true-maher-ghar">
        <h2>A True Maher Ghar (Maternal Home)</h2>
        <p>
          This initiative creates a nurturing environment reminiscent of a <b><i>Maher Ghar,</i></b> a place where women can feel supported, loved, and recharged to take on life’s challenges with renewed vigor.
        </p>
      </div>
    </div>
  );
};

export default WomenDevelopment;
